<template>

  <DefaultLayout>
    <div>
      <!-- Breadcrumb Section Begin -->
      <div class="breacrumb-section">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="breadcrumb-text">
                <router-link to="/"><i class="mdi mdi-home"></i> {{ $t("main.home") }}</router-link>
                <span>{{ $t("auth.forget-password") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Breadcrumb Form Section Begin -->

      <!-- Register Section Begin -->
      <div class="register-login-section spad">
        <div class="container">
          <div class="row">
            <div class="text-center col-lg-8 offset-lg-2 alert alert-success" v-if="success">
              <p v-if="success">
                {{ message }}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="text-center col-lg-8 offset-lg-2 alert alert-danger" v-if="has_error && !success">
              <p v-if="error !== null">
                {{ error }}
              </p>
              <p v-else>
                {{
                  $t("auth.error.message", { action: $t("auth.reset-password") })
                }}
              </p>
            </div>

            <div class="col-lg-6 offset-lg-3">
              <div class="loader" v-if="loader"></div>

              <div class="login-form">
                <form method="post" @submit.prevent="forgetPassword" v-if="!success">
                  <div class="group-input" v-bind:class="{ 'has-error': has_error && errors.email }">
                    <label for="email" v-bind:class="{
                      'text-danger': has_error && errors.email,
                    }">{{ $t("attr.email") }} *</label>
                    <input type="text" id="email" v-model="email" />
                    <span class="text-danger help-block" v-if="has_error && errors.email">{{ errors.email[0] }}</span>
                  </div>
                  <button type="submit" class="btn-site btn-auth">
                    {{ $t("action.send") }}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Register Form Section End -->
   </div>
  </DefaultLayout>
</template>

<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue';

export default {
  data() {
    return {
      email: "",
      has_error: false,
      error: "",
      errors: {},
      success: false,
      loader: false,
    };
  },
  components: {
    DefaultLayout,
  },
  methods: {
    forgetPassword() {
      var app=this;
      let email=this.email;
      app.loader=true;
      this.$store
        .dispatch("forgetPassword", { email })
        .then(function () {
          app.message=app.$t("action.resetLinkSent");
          app.success=true;
          app.loader=false;
        })
        .catch(function (err) {
          app.has_error=true;
          app.error=err.response.data.message;
          app.errors=err.response.data.data||{};
          app.loader=false;
        });
    },
  },
};
</script>
